// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"e9032c79","103":"73e19c74","106":"07c30d3e","149":"dec0dc38","237":"809696b9","437":"2d0e5c72","638":"6f73d238","881":"e665278b","971":"0f6d795d"}[chunkId] + ".chunk.js";
};